import { signOut as fbSignOut, getAuth, signInWithEmailAndPassword } from "firebase/auth";

// Ensure config.ts runs first by importing the same app
import "./config";

const auth = getAuth();

export const signIn = (email: string, password: string) =>
  signInWithEmailAndPassword(auth, email, password);

export const signOut = () => fbSignOut(auth);

export { auth };
